module.exports = __webpack_public_path__ + "376d06ff03b082683e73d8e36889a223.png";